/** @format */
/* eslint-disable max-len */

import { ATCItem, HeaderStoreSelection, IATC } from '@shared/data-access/interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartDao, CartService, Logger } from '@shared/data-access/services';
import {
	addToCartErrored,
	addToCartSucceeded
} from 'libs/pdp/add-to-cart/data-access/src/lib/+state/add-to-cart.actions';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { SelectedBundleSkus } from '@pdp/data-access/interfaces';
import { Store } from '@ngrx/store';
import { addToCartTriggered } from './bundles.actions';
import { concatLatestFrom } from '@ngrx/operators';
import { of } from 'rxjs';
import { selectAtcFulfillmentOption } from 'libs/pdp/add-to-cart/data-access/src/lib/+state/add-to-cart.selectors';
import { selectSelectedBundleSkus } from './bundles.selectors';
import { selectUserStoreInfo } from '@state/data-access';

@Injectable()
export class BundlesEffects {
	addToCartTriggered$ = createEffect(() =>
		this.actions$.pipe(
			ofType(addToCartTriggered),
			concatLatestFrom(() => [
				this.store.select(selectSelectedBundleSkus),
				this.store.select(selectUserStoreInfo),
				this.store.select(selectAtcFulfillmentOption)
			]),
			switchMap(
				(
					info: [
						ReturnType<typeof addToCartTriggered>,
						SelectedBundleSkus[],
						HeaderStoreSelection | null,
						string | null
					]
				) =>
					this.addToCart(info).pipe(
						map(() => addToCartSucceeded()),
						catchError((error) => {
							this.cartService.fireATCErrorAnalyticEvent(error);
							return of(addToCartErrored());
						})
					)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private store: Store,
		public logger: Logger,
		public cartService: CartService,
		public cartDao: CartDao
	) {}
	public addToCart(
		data: [
			ReturnType<typeof addToCartTriggered>,
			SelectedBundleSkus[],
			HeaderStoreSelection | null,
			string | null
		]
	) {
		const atcObjects = [];

		for (const selectedProductBundle of data[1]) {
			const atcObject: IATC = {
				ATCOriginated: 'PdpBundlePage',
				productTitle: selectedProductBundle.sku.name,
				productEcode: selectedProductBundle.sku.parentPartNumber,
				skuOfferPrice: selectedProductBundle.sku.prices.offerPrice,
				skuListPrice: selectedProductBundle.sku.prices.listPrice,
				skuId: selectedProductBundle.sku.partNumber,
				skuDefAttributes: selectedProductBundle.sku.definingAttributes,
				skuCatentryId: selectedProductBundle.sku.catentryId,
				quantity: parseInt(selectedProductBundle.quantity, 10),
				isProductAddOn: false,
				isCustomizable: false,
				isBopis: data[3] === 'bopis'
			};

			atcObjects.push(atcObject);
		}

		const atcItem = {
			atcObject: atcObjects,
			retries: 1,
			launchConfig: {}
		} as ATCItem;

		return this.cartDao.addSkuCollectionToCart$(
			atcItem.atcObject,
			data[2]?.store,
			atcItem.retries
		);
	}
}
